import { render, staticRenderFns } from "./task-model-view-right-info.vue?vue&type=template&id=58f11408&scoped=true&"
import script from "./task-model-view-right-info.vue?vue&type=script&lang=ts&"
export * from "./task-model-view-right-info.vue?vue&type=script&lang=ts&"
import style0 from "./task-model-view-right-info.vue?vue&type=style&index=0&id=58f11408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f11408",
  null
  
)

export default component.exports